import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const BraToteBag = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.accessories.BraToteBag.itemName}
      name={AW23.accessories.BraToteBag.itemName}
      price={AW23.accessories.BraToteBag.itemPrice}
      fabric={AW23.accessories.BraToteBag.itemFabric}
      src={AW23.accessories.BraToteBag.sizeChart}
      divId={AW23.accessories.BraToteBag.shopifyDivId}
      mainId={AW23.accessories.BraToteBag.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.accessories.BraToteBag.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.accessories.BraToteBag.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default BraToteBag;
